import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FileQuestion, ShieldOff } from 'lucide-react';
import { Button } from 'components/ui/button';

// A mistyped URL, a renamed page and "you're not allowed here" all used to redirect
// silently to the dashboard, so nobody could tell which had happened — and `replace`
// meant Back couldn't get them out either.
function Status({ icon: Icon, title, body }) {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <Icon className="h-12 w-12 text-muted-foreground mb-4" aria-hidden="true" />
      <h1 className="text-xl font-semibold text-foreground">{title}</h1>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">{body}</p>
      <div className="mt-6 flex gap-2">
        <Button variant="outline" onClick={() => navigate(-1)}>Go back</Button>
        <Button asChild><Link to="/dashboard">Go to dashboard</Link></Button>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <Status
      icon={FileQuestion}
      title="Page not found"
      body="That address doesn't match any page. It may have been renamed or removed — check the link, or head back to where you were."
    />
  );
}

export function AccessDeniedPage() {
  return (
    <Status
      icon={ShieldOff}
      title="You don't have access to this page"
      body="Your role doesn't include this module. If you need it, ask an administrator to grant the permission."
    />
  );
}

export default NotFoundPage;
